import Paragraph from "./Paragraph";
import Title from "./Title";

export default { Paragraph, Title };
